import { IProductPricesApi } from "api/interfaces/category-api.type";
import axios from "fetch-api/fetch-api";

function getProductPrice(sku: string) {
  return axios.get<IProductPricesApi>(`s/get-product-price?sku=${sku}`);
}

export default getProductPrice;
